import { BaseError } from './base';

export class WalletAccountNotSelectedError extends BaseError {
  public readonly expectedAddress: string;
  public readonly selectedAddress: string;

  constructor(params: { expectedAddress: string; selectedAddress: string }) {
    const currentAccountInfo = params.selectedAddress
      ? ` (currently ${params.selectedAddress})`
      : '';
    super({
      cause: null,
      code: 'wallet_account_not_selected_error',
      docsUrl: null,
      name: 'WalletAccountNotSelected',
      shortMessage: `This wallet only supports signing with its selected account${currentAccountInfo}. Please select account ${params.expectedAddress} in your wallet app and try again`,
    });

    this.expectedAddress = params.expectedAddress;
    this.selectedAddress = params.selectedAddress;
  }
}
